import React from 'react';

const QuestionSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      className={className}
    >
      <path
        d="M10 15V14.9929M10 12.8571C10 9.64291 13 10.3571 13 7.85715C13 6.2792 11.6568 5.00002 10 5.00002C8.6567 5.00002 7.51961 5.84085 7.13733 7.00002M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02946 5.02944 1.00002 10 1.00002C14.9706 1.00002 19 5.02946 19 10Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QuestionSVG;
